import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export function modalSure(title) {
  var _this = this;
  return new Promise(function (resolve, reject) {
    _this.$confirm("\u786E\u5B9A".concat(title || '删除该条数据吗', "?"), '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      resolve();
    }).catch(function () {
      _this.$message({
        type: 'info',
        message: '已取消'
      });
    });
  });
}
export function modalSureDelete(title) {
  var _this2 = this;
  return new Promise(function (resolve, reject) {
    _this2.$confirm("".concat(title || '该记录删除后不可恢复，您确认删除吗', "?"), '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      resolve();
    }).catch(function (action) {
      _this2.$message({
        type: 'info',
        message: '已取消'
      });
    });
  });
}
export function returnSure(title) {
  var _this3 = this;
  return new Promise(function (resolve, reject) {
    _this3.$confirm("\u786E\u5B9A".concat(title || '删除该条数据吗', "?"), '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      resolve();
    }).catch(function () {
      _this3.$message({
        type: 'info',
        message: '已取消'
      });
    });
  });
}
/**
 * @description 表格列表中删除最后一页中的唯一一个数据的操作
 */
export function handleDeleteTable(length, tableFrom) {
  if (length === 1 && tableFrom.page > 1) return tableFrom.page = tableFrom.page - 1;
}
function parseTime(time) {
  var _time$split$map = time.split(':').map(Number),
    _time$split$map2 = _slicedToArray(_time$split$map, 2),
    hours = _time$split$map2[0],
    minutes = _time$split$map2[1];
  return new Date(0, 0, 0, hours, minutes).getTime();
}
function parseTimeM(timeStr) {
  var _timeStr$split$map = timeStr.split(':').map(Number),
    _timeStr$split$map2 = _slicedToArray(_timeStr$split$map, 2),
    hours = _timeStr$split$map2[0],
    minutes = _timeStr$split$map2[1];
  return hours * 60 + minutes; // 返回分钟数
}

// 时间分段计算方法；
export function splitTimeRange(timeRange, intervalMinutes) {
  var _timeRange = _slicedToArray(timeRange, 2),
    startTime = _timeRange[0],
    endTime = _timeRange[1];
  var start = parseTime(startTime);
  var end = parseTime(endTime);
  var interval = intervalMinutes * 60 * 1000; // 转换为毫秒

  var result = [];
  var currentStart = start;
  while (currentStart + interval <= end) {
    var currentEnd = currentStart + interval;
    var data = {
      start: formatTime(currentStart),
      end: formatTime(currentEnd),
      stock: 0
    };
    result.push(data);
    currentStart = currentEnd;
  }

  // 处理最后一个时间段
  if (currentStart < end) {
    var remainingTime = end - currentStart;
    if (remainingTime >= interval) {
      var _data = {
        start: formatTime(currentStart),
        end: formatTime(end),
        stock: 0
      };
      result.push(_data);
    }
  }
  return result;
}
function formatTime(time) {
  var date = new Date(time);
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  return "".concat(hours, ":").concat(minutes);
}

// 判断是否有交集
export function hasIntersection(timeRanges) {
  for (var i = 0; i < timeRanges.length; i++) {
    for (var j = i + 1; j < timeRanges.length; j++) {
      console.log(timeRanges[i].map(parseTimeM), timeRanges[j].map(parseTimeM));
      var _timeRanges$i$map = timeRanges[i].map(parseTimeM),
        _timeRanges$i$map2 = _slicedToArray(_timeRanges$i$map, 2),
        start1 = _timeRanges$i$map2[0],
        end1 = _timeRanges$i$map2[1];
      var _timeRanges$j$map = timeRanges[j].map(parseTimeM),
        _timeRanges$j$map2 = _slicedToArray(_timeRanges$j$map, 2),
        start2 = _timeRanges$j$map2[0],
        end2 = _timeRanges$j$map2[1];
      if (start1 <= end2 && end1 >= start2) {
        return true;
      }
    }
  }
  return false;
}
// 判断是否递增
export function isTimeRangesIncreasing(timeRanges) {
  for (var i = 1; i < timeRanges.length; i++) {
    var _timeRanges$map = timeRanges[i - 1].map(parseTimeM),
      _timeRanges$map2 = _slicedToArray(_timeRanges$map, 2),
      start1 = _timeRanges$map2[0],
      end1 = _timeRanges$map2[1];
    var _timeRanges$i$map3 = timeRanges[i].map(parseTimeM),
      _timeRanges$i$map4 = _slicedToArray(_timeRanges$i$map3, 2),
      start2 = _timeRanges$i$map4[0],
      end2 = _timeRanges$i$map4[1];
    if (end1 > start2) {
      return false;
    }
  }
  return true;
}